import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { getExpiringEmployees } from "../../../config/services/employeeServices";
import ResponseFilter from "../../../ResponseFilter";

const ExpiringEmployeesRender = () => {
    const [data, setData] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [pageNo, setPageNo] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);

    const fetchMoreData = async () => {
        if (loading) return;
        setLoading(true);
        try {
            const res = await getExpiringEmployees(`pageNo=${pageNo}&count=20`);
            if (res.data.statusCode === 1) {
                let { status, resData } = ResponseFilter(res);
                if (status && resData) {
                    const newRecords = resData.employeesList || [];
                    setData(prevData => [...prevData, ...newRecords]);
                    setTotalCount(resData.totalCount);
                    setPageNo(prevPage => prevPage + 1);

                    if (data.length + newRecords.length >= resData.totalCount || newRecords.length === 0) {
                        setHasMore(false);
                    }
                } else {
                    setHasMore(false);
                }
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching expiring employees:", error);
            setHasMore(false);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchMoreData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (data.length === 0 && !hasMore) {
        return null; // Return nothing if no employees are expiring
    }

    return (
        <div className="row dashboard_new_card_container mx-3 mb-4 mt-4">
            <div className="mt-3 ml-4 d-flex w-100">
                <p className="emp_dashboard_card_title">
                    Probation/Training/Internship
                </p>
                <p className="emp_dashboard_card_title ml-2">{`(${totalCount})`}</p>
            </div>
            <div className="card-body card_body mx-1" style={{ paddingTop: '10px' }}>
                <InfiniteScroll
                    dataLength={data.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={<div style={{ textAlign: "center", padding: "10px" }}><Spin /></div>}
                    endMessage={
                        <div style={{ textAlign: "center", padding: "10px", color: "#888" }}>
                            <b>No more records</b>
                        </div>
                    }
                    style={{ overflowX: 'hidden' }}
                >
                    <table className="table table-hover" style={{ width: '100%', marginBottom: 0 }}>
                        <thead style={{ backgroundColor: '#f0f2f5' }}>
                            <tr>
                                <th style={{ fontWeight: '600', padding: '12px 10px', fontSize: '15px', color: '#000' }}>Employee Name</th>
                                <th style={{ fontWeight: '600', padding: '12px 10px', fontSize: '15px', color: '#000' }}>Emp Code</th>
                                <th style={{ fontWeight: '600', padding: '12px 10px', fontSize: '15px', color: '#000' }}>Type</th>
                                <th style={{ fontWeight: '600', padding: '12px 10px', fontSize: '15px', color: '#000' }}>Joining Date</th>
                                <th style={{ fontWeight: '600', padding: '12px 10px', fontSize: '15px', color: '#000' }}>Completion Date</th>
                                <th style={{ fontWeight: '600', padding: '12px 10px', fontSize: '15px', color: '#000' }}>Days Left</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((record) => {
                                let typeText = "Unknown";
                                if (record.employeeType === "1") typeText = "Fresher/Training";
                                else if (record.employeeType === "2") typeText = "Probation";
                                else if (record.employeeType === "4") typeText = "Intern";

                                const diff = moment(Number(record.expiryDate)).diff(moment().startOf('day'), 'days');
                                let color = "black";
                                if (diff <= 7) color = "red";
                                else if (diff <= 15) color = "orange";

                                return (
                                    <tr key={record.employeeId}>
                                        <td style={{ padding: '12px 10px', fontSize: '14px' }}>
                                            {record.firstName} {record.lastName}
                                        </td>
                                        <td style={{ padding: '12px 10px', fontSize: '14px' }}>{record.empId}</td>
                                        <td style={{ padding: '12px 10px', fontSize: '14px' }}>{typeText}</td>
                                        <td style={{ padding: '12px 10px', fontSize: '14px' }}>{moment(Number(record.dateOfJoining)).format("DD-MM-YYYY")}</td>
                                        <td style={{ padding: '12px 10px', fontSize: '14px' }}>{moment(Number(record.expiryDate)).format("DD-MM-YYYY")}</td>
                                        <td style={{ padding: '12px 10px', fontSize: '14px' }}>
                                            <span style={{ color, fontWeight: 'bold' }}>{diff} Days</span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </InfiniteScroll>
            </div>
        </div>
    );
};

export default ExpiringEmployeesRender;
